































































import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { Map } from 'client-website-ts-library/components';

import Form from '@/components/Forms/Form.vue';
import { Context, Coordinate, MapMarker, MapSettings, Office } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { ContextItemType } from 'client-website-ts-library/types/Context';

@Component({
  components: {
    Form,
    Map,
  },
})
export default class Contact extends Mixins(View) {
  private formCtx: Context | null = null;

  private office: Office | null = null

  private mapSettings: MapSettings | null = null;

  mounted() {
    API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
      this.office = office;

      this.mapSettings = new MapSettings({
        Markers: [
          new MapMarker({
            Address: `${this.office.AddressLine1} ${this.office.AddressLine2}`,
            Title: this.office.FranchiseName,
            Coordinate: {
              Lat: -16.9142206,
              Lon: 145.7517838,
            },
          }),
        ],
      });
    });

    this.formCtx = {
      ClientWebsiteId: Config.Website.Id,
      Items: [
        {
          Type: ContextItemType.Office,
          Id: Config.Website.Settings!.WebsiteId,
        },
      ],
    };
  }
}
